import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function MyAppointments() {
    const navigate = useNavigate();
    const [bookings, setBookings] = useState([]);
    const [loading, setLoading] = useState(true);

    // --- 1. Fetch Data ---
    useEffect(() => {
        const userString = localStorage.getItem('DDoctorUser');
        if (!userString) {
            navigate('/');
            return;
        }
        const user = JSON.parse(userString);

        axios.get(`${process.env.REACT_APP_API_BASE_URL}/bookings/user/${user._id}`)
            .then(res => {
                setBookings(res.data.reverse());
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, [navigate]);

    // --- 2. Cancel Logic ---
    const handleCancel = (bookingId) => {
        if (!window.confirm("Are you sure you want to cancel this appointment?")) return;

        axios.put(`${process.env.REACT_APP_API_BASE_URL}/bookings/cancel/${bookingId}`)
            .then(res => {
                // Instead of removing it, we find it and change status to 'Cancelled'
                setBookings(bookings.map(b =>
                    b._id === bookingId ? { ...b, status: 'Cancelled' } : b
                ));
            })
            .catch(err => alert("Error cancelling appointment"));
    };




    // --- 3. Pay Online Logic ---
    const handlePay = (bookingId) => {
        // Navigate to payment page AND pass the booking ID
        navigate('/payment', { state: { bookingId: bookingId } });
    };
    if (loading) return <div className="text-center mt-5 pt-5"><h3>Loading appointments...</h3></div>;

    return (
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', paddingTop: '80px', paddingBottom: '50px' }}>
            <div className="container">
                <h3 className="mb-4 fw-bold text-dark">My appointments</h3>

                {bookings.length === 0 ? (
                    <div className="text-center p-5 bg-white rounded shadow-sm">
                        <h5 className="text-muted">No upcoming appointments.</h5>
                        <button onClick={() => navigate('/doctors')} className="btn btn-primary mt-3">Find a Doctor</button>
                    </div>
                ) : (
                    <div className="d-flex flex-column gap-3">
                        {bookings.map((appt) => (
                            // --- APPOINTMENT CARD START ---
                            <div key={appt._id} className="bg-white p-4 rounded border shadow-sm d-flex flex-column flex-md-row align-items-center gap-4">

                                {/* 1. Doctor Image */}
                                <div style={{ width: '120px', height: '120px', flexShrink: 0 }}>
                                    <img
                                        src={appt.doctorImage ? `/images/${appt.doctorImage}` : '/images/default-doc-avatar.png'} alt="Doctor"
                                        className="w-100 h-100 rounded object-fit-cover bg-light"
                                    />
                                </div>

                                {/* 2. Details Section */}
                                <div className="flex-grow-1 text-center text-md-start">
                                    <h5 className="fw-bold mb-1 text-dark"> {appt.doctorName}</h5>
                                    <p className="text-muted mb-2">{appt.specialty}</p>

                                    <div className="text-secondary small mb-2">
                                        <strong>Address:</strong><br />
                                        Online / Tele-consultation (or Clinic Address)
                                    </div>

                                    <div className="fw-bold text-dark">
                                        Date & Time: <span className="text-primary">{appt.appointmentDate} | {appt.appointmentTime}</span>
                                    </div>
                                </div>

                                {/* 3. Action Buttons (Right Side) */}
                                {/* <div className="d-flex flex-column gap-2" style={{ minWidth: '200px' }}>

                                    {appt.status === 'Cancelled' ? (
                                        <button
                                            className="btn"
                                            style={{
                                                border: '1px solid #dc3545',
                                                color: '#dc3545',
                                                backgroundColor: 'white',
                                                cursor: 'default',
                                                opacity: 1
                                            }}
                                            disabled
                                        >
                                            Appointment cancelled
                                        </button>
                                    ) : (
                                        <>
                                            <button
                                                onClick={() => handlePay(appt._id)}
                                                className="btn btn-outline-secondary w-100"
                                            >
                                                Pay Online
                                            </button>

                                            <button
                                                onClick={() => handleCancel(appt._id)}
                                                className="btn btn-outline-danger w-100"
                                            >
                                                Cancel appointment
                                            </button>
                                        </>
                                    )}
                                </div> */}

                                <div className="d-flex flex-column gap-2" style={{ minWidth: '200px' }}>

                                    {/* SHOW PAY BUTTON ONLY IF CONFIRMED */}
                                    {appt.status === 'Confirmed' && (
                                        <button
                                            onClick={() => handlePay(appt._id)}
                                            className="btn btn-success w-100 fw-bold"
                                        >
                                            <i className="bi bi-credit-card me-2"></i> Proceed to Payment
                                        </button>
                                    )}

                                    {/* Disabled States */}
                                    {appt.status === 'Pending' && (
                                        <button className="btn btn-light border w-100 text-muted" disabled>
                                            <i className="bi bi-hourglass-split"></i> Waiting for Doctor
                                        </button>
                                    )}

                                    {appt.status === 'Paid' && (
                                        <button className="btn btn-outline-success w-100" disabled>
                                            <i className="bi bi-check-circle-fill"></i> Paid Successfully
                                        </button>
                                    )}

                                    {appt.status !== 'Cancelled' && appt.status !== 'Paid' && (
                                        <button
                                            onClick={() => handleCancel(appt._id)}
                                            className="btn btn-outline-danger w-100"
                                        >
                                            Cancel Appointment
                                        </button>
                                    )}

                                    {appt.status === 'Cancelled' && (
                                        <span className="text-danger text-center border p-2 rounded bg-light">Cancelled</span>
                                    )}
                                </div>

                            </div>
                            // --- APPOINTMENT CARD END ---
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default MyAppointments;